import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-apply_job",
  "use": "icon-apply_job-usage",
  "viewBox": "0 0 26 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 22\" id=\"icon-apply_job\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0-3h28v28H0z\" /><path d=\"M25.667 20.341a1.167 1.167 0 0 1-1.158 1.159H3.491c-.64 0-1.158-.52-1.158-1.159v-1.174h21V5.517L14 13.917 2.333 3.417v-1.75C2.333 1.022 2.856.5 3.5.5h21c.644 0 1.167.522 1.167 1.167V20.34ZM5.173 2.834 14 10.778l8.827-7.945H5.173ZM0 14.5h9.333v2.333H0V14.5Zm0-5.833h5.833V11H0V8.667Z\" fill=\"#BFBFBF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol